/**
 * Reeluxs:商品轮播(resource-list carousel)加载后回到第一张。
 *
 * 背景(2026-09-15):店主 iPhone Safari 上首页 New Arrivals 轮播一打开就停在第 4 张;
 * 桌面 Chrome、Chrome iPhone 模拟、Playwright WebKit iPhone 模拟(含 / 不含 Atome)都复现不了,
 * 轮播的 initial-slide 也是 0。最可能是 iOS Safari 恢复了滚动容器的历史位置。
 * 这里在页面 load 后若用户还没碰过轮播,就把它拉回第 1 张;只处理 resource-list 轮播,
 * 不碰商品页图库。
 */
(function () {
  if (!('querySelectorAll' in document)) return;
  var touched = new WeakSet();
  function scrollers() {
    return Array.prototype.slice.call(
      document.querySelectorAll('slideshow-component.resource-list__carousel [ref="scroller"]')
    );
  }
  function markTouched(e) {
    var s = e.currentTarget;
    touched.add(s);
  }
  function arm() {
    scrollers().forEach(function (s) {
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (t) {
        s.addEventListener(t, markTouched, { passive: true, once: true });
      });
    });
  }
  function reset() {
    scrollers().forEach(function (s) {
      if (touched.has(s) || s.scrollLeft === 0) return;
      s.scrollTo({ left: 0, behavior: 'instant' });
    });
  }
  function run() {
    arm();
    setTimeout(reset, 300);
    setTimeout(reset, 1500);
    setTimeout(reset, 3000);
  }
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
  // iOS Safari 从 bfcache 返回时也可能带着旧位置。
  window.addEventListener('pageshow', function (e) { if (e.persisted) run(); });
})();
